import React from "react";
import RegistrationForm from "../../Components/RegistrationForm/RegistrationForm";
import TimeSetter from "../../Components/TimeSetter/TimeSetter";
import TimeSlotHandler from "../../Components/TimeSlotsHandler/TimeSlotHandler";
import InputErrorMessage from "../../Components/InputErrorMessage/InputErrorMessage";
import jwt_decode from "jwt-decode";
import GooLoader from "../../Components/GooLoader/GooLoader";
import ErrorBox from "../../Components/ErrorBox/ErrorBox";
import { Helmet } from "react-helmet-async";
import { withRouter } from "react-router-dom";
import "./Availability.css";

class Availability extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      meeting_days: [],
      error: "",
      isLoading: true,
      title: "",
      body: "",
      showButton: false,
    };

    this.handleErrorMsg = this.handleErrorMsg.bind(this);
    this.handleAddingTimeSlot = this.handleAddingTimeSlot.bind(this);
    this.handleTimeSlotOnChange = this.handleTimeSlotOnChange.bind(this);
    this.handleDeleteTimeSlot = this.handleDeleteTimeSlot.bind(this);
    this.handleMatchingCriteria7 = this.handleMatchingCriteria7.bind(this);
    this.handleBackButtonClick = this.handleBackButtonClick.bind(this);
  }

  componentDidMount() {
    let token = localStorage.getItem("token");
    if (!token) {
      this.props.history.push("/");
    } else {
      let decoded = jwt_decode(token);
      if (
        this.props.location.state === undefined ||
        !this.props.location.state.userData ||
        !this.props.location.state.userData.matching_criteria
      ) {
        if (!decoded.active) {
          this.props.history.push("/");
        } else {
          this.props.history.push("/dashboard");
        }
      } else {
        let userData = this.props.location.state.userData;
        if (!decoded.active) {
          this.props.history.push("/payment", { userData: userData });
        } else {
          const { growth_goal_match } = userData.matching_criteria;
          if (!growth_goal_match) {
            this.props.history.push("/matching-criteria-6", {
              userData: userData,
            });
          } else {
            if (this.props.matching_criteria_7 !== "") {
              this.setState({
                meeting_days: this.props.matching_criteria_7,
                isLoading: false,
              });
            } else {
              this.setState({
                isLoading: false,
              });
            }
          }
        }
      }
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.meeting_days !== prevState.meeting_days) {
      if (this.state.meeting_days.length > 0) {
        let displayButton = true;
        this.state.meeting_days.forEach((meetingDay) => {
          if (
            meetingDay.hours.length === 0 ||
            meetingDay.weekdays.length === 0
          ) {
            displayButton = false;
          }
        });
        if (displayButton) {
          this.setState({
            showButton: true,
          });
        } else {
          this.setState({
            showButton: false,
          });
        }
      } else {
        this.setState({
          showButton: false,
        });
      }
    }
  }

  handleErrorMsg(title, body) {
    this.setState(
      {
        title: title,
        body: body,
      },
      () => {
        setTimeout(() => {
          this.setState({
            title: "",
            body: "",
          });
        }, 3000);
      }
    );
  }

  handleMatchingCriteria7() {
    let meeting_days = [...this.state.meeting_days];
    if (meeting_days.length > 0) {
      let emptyTimeSlotArray = [];
      meeting_days.forEach((d) => {
        if (d.hours.length > 0 && d.weekdays.length > 0) {
          return;
        } else {
          emptyTimeSlotArray.push(d);
        }
      });
      if (emptyTimeSlotArray.length > 0) {
        this.setState({
          error: "Timeslots should not be empty",
        });
      } else {
        this.setState({
          error: "",
        });
        let userData = this.props.location.state.userData;
        this.props.history.push("/account-links", {
          userData: {
            ...userData,
            matching_criteria: {
              ...userData.matching_criteria,
              meeting_days: meeting_days,
            },
          },
        });
      }
    } else {
      this.handleErrorMsg("Error", "Make sure to add at least one time slot");
    }
  }

  handleBackButtonClick() {
    this.props.history.goBack();
  }

  handleAddingTimeSlot(value) {
    if (this.state.meeting_days.length > 4) {
      this.setState({
        error: "You have reached maximum number of time slots",
      });
    } else {
      this.setState(
        (prevState) => ({
          error: "",
          meeting_days: [
            ...prevState.meeting_days,
            {
              ...value,
            },
          ],
        }),
        () => {
          this.props.setMatchingCriteria7(this.state.meeting_days);
        }
      );
    }
  }

  handleTimeSlotOnChange(index, meetingDay) {
    this.setState(
      (prevState) => ({
        meeting_days: [
          ...prevState.meeting_days.map((d, i) => {
            if (i === index) {
              return {
                ...meetingDay,
              };
            } else {
              return d;
            }
          }),
        ],
      }),
      () => {
        this.props.setMatchingCriteria7(this.state.meeting_days);
      }
    );
  }

  handleDeleteTimeSlot(index) {
    let meetingDays = [...this.state.meeting_days];
    meetingDays.splice(index, 1);
    this.setState(
      {
        meeting_days: meetingDays,
      },
      () => {
        this.props.setMatchingCriteria7(this.state.meeting_days);
      }
    );
  }

  render() {
    return (
      <React.Fragment>
        {this.state.isLoading ? <GooLoader /> : null}

        <RegistrationForm
          containerClassName="container-matching-industry-7"
          hasCounter={true}
          step="7"
          hasQuote={true}
          quote="We host meetings five days/week at five different times. Choose the days and times that could work for you."
          headerText="What's your availability for a weekly power hour?"
          primaryButtonText="Next step"
          hasSkip={false}
          handlePrimaryBtnOnClick={this.handleMatchingCriteria7}
          activatePrimaryWithEnter={true}
          showButton={this.state.showButton}
          showBackButton={true}
          backButtonText="Back"
          handleBackButtonClick={this.handleBackButtonClick}
        >
          <Helmet>
            <title>Astronomic Network</title>
            <meta
              name="description"
              content="Austin entrepreneurs helping each other win"
            />
          </Helmet>

          {this.state.error !== "" ? (
            <div className="form-container-body-row">
              <InputErrorMessage errorText={this.state.error} />
            </div>
          ) : null}

          {this.state.meeting_days.length > 0 ? (
            <div className="form-container-body-row">
              <TimeSlotHandler
                meetingDays={this.state.meeting_days}
                handleTimeSlotOnChange={this.handleTimeSlotOnChange}
                handleDeleteTimeSlot={this.handleDeleteTimeSlot}
                zIndexValue={3}
              />
            </div>
          ) : null}
          <div className="form-container-body-row">
            <TimeSetter
              handleAddingTimeSlot={this.handleAddingTimeSlot}
              zIndexValue={4}
            />
          </div>
        </RegistrationForm>
        <ErrorBox title={this.state.title} body={this.state.body} />
      </React.Fragment>
    );
  }
}

export default withRouter(Availability);
